import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
//import 'antd/dist/antd.css'; 
import 'antd/dist/result.css';

import { connect } from 'react-redux'
import * as actions from './store/actions/auth'

import LoginLayout from './views/containers/LoginLayout'
import Login from './views/containers/Login';
import SaccoLayout from './views/containers/Saccoslayout'
import Breadcrumbs from './Breadcrumbs';
//All components
import MineralLicenceList from './views/containers/MineralLicenceCategoriesList';
import AccountList from './views/containers/AccountsListView'
import AccountDetail from './views/containers/AccountDetailView'

import DocumentTypeList from './views/containers/DocumentTypes';
import AgreementTypeList from './views/containers/AgreementTypes';
import LicenceCommodities_All from './views/containers/LicenceCommodities_All';
import Jurisdictions from './views/containers/Jurisdictions';
import LicencesTab from './views/containers/LicencesTab';
import DashBoard from './views/containers/DashBoard';
import Parties from './views/containers/Parties';
import OtherSettings from './views/containers/OtherSettings';
import Licence_DTabs from './views/containers/Licence_DTabs';
import AdminTools from './views/containers/AdminTools';
// Containers
import StaffRoles from './views/containers/StaffRoles';
import WorkFlows from './views/containers/WorkFlows';
import Document_Tab from './views/containers/Document_Tab';
import PortalUserList from './views/containers/PortalUserListView';
import ActionList from './views/containers/Actions';
import LicenceApplications from './views/containers/LicenceApplications';
import CompleteAction from './views/components/CompleteAction';
import Licences_Granted from './views/containers/Licences_Granted';

const App = (props) => {

  const [all_routes, setall_routes] = useState(
    [
      {
        key:1,
        name:"Home",
        Path:"/",
        component:DashBoard

      },
      {
        key:2,
        name:"Users",
        Path:"/useraccounts",
        component:AccountList
      },
      {
        key:3,
        name:"User Details",
        Path:"/useraccounts/:accountID",
        component:AccountDetail
      },
      {
        key:4,
        name:"Mineral Licence Categories",
        Path:"/mineral_rights_categories",
        component:MineralLicenceList
      },

      {
        key:4,
        name:"Documents",
        Path:"/documents",
        component:Document_Tab
      },

      {
        key:5,
        name:"Agreement Types",
        Path:"/agreement_types",
        component:AgreementTypeList
      },

      {
        key:6,
        name:"Commodities",
        Path:"/commodities",
        component:LicenceCommodities_All
      },
      
      {
        key:7,
        name:"Jurisdictions",
        Path:"/jurisdictions",
        component:Jurisdictions
      },

      {
        key:8,
        name:"Licence Types",
        Path:"/licence_types",
        component:LicencesTab
      },

      {
        key:9,
        name:"Parties",
        Path:"/parties",
        component:Parties
      },
      {
        key:10,
        name:"Other Settings",
        Path:"/othersettings",
        component:OtherSettings
      },
      {
        key:11,
        name:"Licence Details",
        Path:"/licence_details/:licenceID",
        component:Licence_DTabs
      },
      {
        key:12,
        name:"Admin tools",
        Path:"/admin_tools",
        component:AdminTools
      },

      {
        key:13,
        name:"Actions",
        Path:"/actions",
        component:ActionList
      },
      
      {
        key:14,
        name:"Staff Roles",
        Path:"/staff_roles",
        component:StaffRoles
      },
      {
        key:15,
        name:"Work Flows",
        Path:"/work_flows",
        component:WorkFlows
      },
      {
        key:16,
        name:"Portal Users",
        Path:"/portal_users",
        component:PortalUserList
      },


      {
        key:17,
        name:"Licence Applications",
        Path:"/licence_applications",
        component:LicenceApplications
      },

      {
        key:18,
        name:"Complete Action",
        Path:"/complete_action/:actionID",
        component:CompleteAction
      },


      {
        key:19,
        name:"Granted Licences",
        Path:"/granted_applications",
        component:Licences_Granted
      },
      
    ]

  );


  useEffect(() => {
    props.onTryAutoSignup();

  }, []);


    return (
      props.isAuthenticated ?
      <Router>
        <SaccoLayout {...props}>

       {/* <Breadcrumbs all_routes={all_routes} />*/}

        <Switch>

          {/* Dynamic restaurant routes */}
          {all_routes.map((route, index) => (
            <Route 
              key={index}
              path={route.Path}
              exact // Ensure exact matching
              component={route.component} // Directly use component prop
              >
            
            </Route>
          ))}

        </Switch>

        </SaccoLayout>
      </Router>
      :
      <Router>
      <LoginLayout>
        <Login />
      </LoginLayout>
      </Router>
    );
  }


const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null
  }
}

const mapDispatchToProps = dispatch =>{
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
